import { FormGroup } from '@angular/forms';
import {
  FormGroupRecords,
  MainForm,
  MainOrSubFormKey,
} from '@app/components/form/common-form/common-form.types';
import { MAIN_FORM_KEY } from '@app/containers/base/containers/editor/editor.constants';
import { every, get, head, isEqual, isString, reduce, values } from 'lodash';
import { BehaviorSubject, rx } from '../rx/rx-wrapper';
import { FormReadyObs, GetFormFunc } from '../types/ui/form-service.type';

export const buildFormGetter = (params: {
  form: FormGroup;
  rightForms: Record<string, FormGroup>;
}): GetFormFunc => {
  const { form, rightForms } = params;

  return (formKey: MainOrSubFormKey) => {
    if (isEqual(formKey, MAIN_FORM_KEY)) {
      return form;
    }

    return get(rightForms, formKey, null);
  };
};

export const buildFormReadyObsGetter = (params: {
  formReady$: BehaviorSubject<Record<MainForm | string, boolean>>;
  form: FormGroup;
  rightForms: Record<string, FormGroup>;
}): FormReadyObs => {
  const { formReady$, form, rightForms } = params;

  return (formKeys: MainOrSubFormKey) => {
    const keys = isString(formKeys) ? [formKeys] : formKeys;

    return formReady$.pipe(
      rx.distinctUntilChanged(),
      rx.filter((formReadyState) =>
        every(keys, (key) => get(formReadyState, key, false)),
      ),
      rx.map(() =>
        reduce(
          keys,
          (acc, formKey) => {
            const curForm = isEqual(formKey, MAIN_FORM_KEY)
              ? form
              : get(rightForms, formKey, null);

            return {
              ...acc,
              [formKey]: curForm,
            };
          },
          {} as FormGroupRecords,
        ),
      ),
      rx.map((forms) =>
        values(forms)?.length === 1 ? head(values(forms)) : forms,
      ),
      rx.take(1),
    );
  };
};
